export { defaultTheme } from './RelayKitTheme.js'

export type { RelayKitTheme } from './RelayKitTheme.js'
